<template>

    <div class="loar">

        <div v-show="loading">
            <foxy-loader></foxy-loader>
            <p class="text-lRegular color__moon mt__16">{{ $t('connexion_in_progress') }}</p>
        </div>

        <div v-show="error">
            <img src="/img/login/error.svg" class="img__64">
            <p class="text-lSemibold mt__16">{{ $t('magic_error_title') }}</p>
            <p class="text-baseRegular color__moon mt__4">{{ $t('invalid_credential_cta_try_again') }}</p>
            <button class="cta-medium-primary mt__32">{{ $t('invalid_credential_cta_try_again') }}</button>

            <div class="cancel" @click="cancel">
                <img src="/img/icons/cancel-blue.svg" class="img__20 mr__4">
                <span class="text-lSemibold color__aquamarine">{{$t('give-up')}}</span>
            </div>
        </div>
    </div>

</template>

<script>
import Vuex from 'vuex'

import Auth from '../modules/auth'
import Consent from '../modules/consent'
import Login from '../modules/login'
import OAuthMicrosoft from '../modules/o-auth/microsoft'

import FoxyLoader from '../components/FoxyLoader'
import SessionStorage from '../helpers/sessionStorage'


export default {

    name: 'login-o-auth-redirect',

    components: {
        FoxyLoader
    },

    computed: {
        ...Vuex.mapGetters([
            'isConnected'
        ]),
        loading() {
            return !this.error
        }
    },

    data() {
        return {
            error: false,
            provider: 'microsoft'
        }
    },

    async mounted() {

        await this.initData()

    },

    methods: {


        async initData() {
            try {

                const {oAuthCodeVerifier, email} = OAuthMicrosoft.getOAuthStep1Data()
                const oAuthCode = this.$route.query.code
                const state = this.$route.query.state

                if (state === 'step1') {
                    // Connect the oauth account to Cleanfox/Foxbrain using a refresh token
                    const connectResult = await Auth.connect(this, email, undefined, this.provider, {
                        oAuthCode,
                        oAuthCodeVerifier
                    })

                    Consent.acceptConsent(email, this.provider)
                    Login.postConnectRoute(this, this.provider, connectResult)
                } else {
                    console.error('LoginOAuthRedirect: Error during login-o-auth state:', state)
                    this.error = true
                }
            } catch (error) {
                console.error('LoginOAuthRedirect: Error during login-o-auth', error)
                this.error = true
            }
        },

        cancel() {
            SessionStorage.removeItem(SessionStorage.KEYS.EMAIL)
            this.isConnected
                ? this.$router.push({path: '/add-inbox'})
                : this.$router.push({path: '/'})
        }
    }
}
</script>

<style lang="scss" scoped>

.loar {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    position: relative;

    > div {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .cancel {
        position: absolute;
        top: 24px;
        right: 16px;
        display: flex;
        cursor: pointer;
        @media screen and (min-width: $above-tablet-length) {
            top: 40px;
            right: 40px;
        }
    }
}

</style>